import{IconCheckmark100 as e}from"../src/elements/IconCheckmark100.js";customElements.define("sp-icon-checkmark100",e);
//# sourceMappingURL=sp-icon-checkmark100.js.map
